<template>
  <div>
    <h1>Export</h1>

    <b-container>
      <b-row>
        <b-col>
          <p class="h4">Export Criteria</p>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" lg="12">
          <BaseEventSelector v-model="criteria.eventId" :v="$v.criteria.eventId" 
            label="Select Event / Testing Site to Export" slug="eventId"/>
        </b-col>
      </b-row>

      <b-row class="mb-4">
        <b-col>
          <b-button variant="primary" @click="exportData">Export</b-button>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>
  import axios from 'axios'
  import axiosRetry from 'axios-retry'
  import { validationMixin } from 'vuelidate'
  import { required, maxLength } from 'vuelidate/lib/validators'
  import BaseEventSelector from '@/components/BaseEventSelector'
  import fileDownload  from 'js-file-download'

  axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

  export default {
    components: {
      BaseEventSelector,
    },
    data: () => ({
      criteria: { },
      isLoading: false,
    }),

    validations() {
        return {
          criteria: { 
            eventId: { required },
          },
        }
    },


    methods: {
      fetchEvents() {
          this.isLoading = true;
          let fullUrl = `${process.env.VUE_APP_API_BASE_URL}/events`
          if (this.showInactive) {
            fullUrl = fullUrl + '/all'
          } 
          axios.get(fullUrl)
            .then(response => {
                this.events = response.data;
                this.isLoading = false;
            })
      },

      search() {
        this.isLoading = true
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/search/submission`, this.criteria)
            .then(response => {
                this.submissions = response.data.content
                this.isLoading = false;
            })
      },

      async showSubmission(item) {
        await this.loadSubmission(item.code)
        this.$bvModal.show('modal-crud')
      },

          loadSubmission(code) {
      this.isLoading = true
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/registration/code/${code}`)
        .then(response => {
            this.submissionData = response.data
            this.isLoading = false
        })
    },

      initialize () {
        this.fetchEvents()
      },

      editItem (item) {
        this.editedIndex = this.events.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$bvModal.show('modal-crud')
      },

      deleteItem (item) {
        const index = this.events.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.events.splice(index, 1)
      },

      close () {
        this.$bvModal.hide('modal-crud')
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
          this.$v.$reset()
          this.fetchEvents()
        }, 300)
      },

      exportData() {
        let requestConfig = {
              //responseType: 'blob', 
              //headers: {
              //  'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
              //},
              params: {         
              }
            }

         axios.get(`${process.env.VUE_APP_API_BASE_URL}/export/event/${this.criteria.eventId}`, requestConfig)
                .then(response => {
                  const buf = Buffer.from(response.data, 'base64')
                  fileDownload(buf, 'submissions.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                })
        
      },
    }
  }
</script>